import React from "react";

import { withTranslation } from 'react-i18next';
import BodyHeader from "../partials/BodyHeader";
import Button from "./../../../components/button";
import { createReservation } from './../../../models/reservation';
import { Alert, Modal, ModalBody } from 'reactstrap';
import iconShower from "../../../assets/images/icon-shower.svg";
import iconBath from "../../../assets/images/icon-bath.svg";
import iconKallah from "../../../assets/images/icon-kallah.svg";
import iconParking from "../../../assets/images/icon-parking.svg";
import iconClockExtra from "../../../assets/images/icon-clock-extra.svg";
import iconChabadBor from "../../../assets/images/icon-chabad-bor.svg";
import iconWheelchair from "../../../assets/images/icon-wheelchair.svg";
import iconSegula from "../../../assets/images/icon-segula.svg";
import ReactSVG from "react-svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SettingsContext } from "../../../components/context";
import CurrencyFormat from "../../../components/snippets/currency-format";
import FridayLocation from "../../../components/fridayLocation";

class CheckinRoomType extends React.Component {
  static contextType = SettingsContext;

  constructor(props, context) {
    super(props);
    this.state = {
      error: null,
      isSubmitting: false,
      bath: props.reservation.bath!==undefined ? props.reservation.bath : (props.siteSettings&&props.siteSettings.defaultSelectBath?true:false),
      parking: props.reservation.parking ? props.reservation.parking : false,
      handicapped: props.reservation.handicapped ? props.reservation.handicapped : false,
      doubleSlot: props.reservation.doubleSlot ? props.reservation.doubleSlot : false,
      kallah: props.reservation.kallah ? props.reservation.kallah : false,
      chabadBor: props.reservation.chabadBor ? props.reservation.chabadBor : false,
      segula: props.reservation.segula ? props.reservation.segula : false,
      privateRoom: props.reservation.privateRoom ? props.reservation.privateRoom : false,
      modalFridayLocation: false,
      fridayInfoRequired: false
    }
    this.savedContext = context;

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.modalToggleFridayLocation = this.modalToggleFridayLocation.bind(this);
    this.fridayCanContinue = this.fridayCanContinue.bind(this);
  }

    componentDidMount() {
    const { settings } = this.context;
    if(settings&&settings.shabbosMode&&settings.shabbosMode.value&&settings.fridayLocationSystem&&settings.fridayLocationSystem.value==="True"&&settings.fridayLocationSystemRequired&&settings.fridayLocationSystemRequired.value==="True"){
      this.setState({fridayInfoRequired: true, modalFridayLocation: true});
    }
  }

    componentDidUpdate(prevProps, prevState) {
    const { settings } = this.context;
    if ( this.context.settings !== this.savedContext.settings ) {
      this.savedContext = this.context;
      if(settings&&settings.shabbosMode&&settings.shabbosMode.value&&settings.fridayLocationSystemRequired&&settings.fridayLocationSystemRequired.value==="True"){
        this.setState({fridayInfoRequired: true, modalFridayLocation: true});
      }
    }
  }

  handleChange(value, type) {
    let option = value.name;
    let prevOptionState = this.state[option];
    let options = {};
    if ( type==='type' ) {
      options = { bath: false, handicapped: false, kallah: false, segula: false };
      if ( this.state[option] ) return;
      if ( option==='shower' ) {
        if ( !this.state.bath && !this.state.kallah && !this.state.handicapped ) return;
        option = 'bath';
        prevOptionState = !prevOptionState;
      }
    }
    options = {...options, [option]: !prevOptionState};
    this.setState(options);
  }

  handleSubmit() {
    let ignoreCutoff = false
    let res = {
      ...this.props.reservation,
      roomType: this.state.handicapped ? "wheelchair" : (this.state.bath?"bath":"shower"),
      bath: this.state.bath,
      handicapped: this.state.handicapped,
      kallah: this.state.kallah,
      doubleSlot: this.state.doubleSlot,
      chabadBor: this.state.chabadBor,
      segula: this.state.segula,
      privateRoom: this.state.privateRoom,
      parking: this.state.parking,
    }

    this.setState({
      isSubmitting: true,
    })

    //If checking in using an existing reservation, remove time and advanceReservation.
    if ( res.replacingReservationId ) {
      res.reservationTime = null;
      res.advanceReservation = false;
      ignoreCutoff = true;
    }

    //Create/modify reservation
    createReservation(res, ignoreCutoff)
      .then(result => {
        this.props.handleUpdateReservation(result, 'checkin-payment');
      }, error => {
        this.setState({
          error,
          isSubmitting: false,
        })
      });
  }

  modalToggleFridayLocation() {
    const { settings } = this.context;
    if(settings&&settings.fridayLocationSystemRequired&&settings.fridayLocationSystemRequired.value==="True"&&!this.props.reservation.fridayLocationId){
      this.setState({modalFridayLocation: true});
    } else {
      this.setState({modalFridayLocation: !this.state.modalFridayLocation});
    }  
  }

  fridayCanContinue() {
    this.setState({fridayInfoRequired: false});
  }

  render() {
    const { t, reservation }  = this.props;
    const { fridayInfoRequired, isSubmitting, error } = this.state;

    return (
      <SettingsContext.Consumer>
        {({settings}) => <>
          {settings!== null?
           <> 
          {settings.fridayLocationSystem&&settings.fridayLocationSystem.value==="True"&&settings.shabbosMode&&settings.shabbosMode.value?
            <Modal isOpen={this.state.modalFridayLocation} toggle={this.modalToggleFridayLocation} centered={true} modalClassName="modal-fridayLocation">
              <div className="modal-header">
                {t("Shabbos/Yom Tov Tevilah Location")}
                <button type="button" onClick={this.modalToggleFridayLocation} className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
              </div>
              <ModalBody>
                <FridayLocation reservation={reservation} toggle={this.modalToggleFridayLocation} handleUpdateReservation={this.props.handleUpdateReservation} fridayCanContinue={this.fridayCanContinue} infoRequired={settings.fridayLocationSystemRequired&&settings.fridayLocationSystemRequired.value==="True"} cancelLink="/receptionist" />
              </ModalBody>
            </Modal>
          :null}
          <BodyHeader isEditingReservation={reservation.reservationId||reservation.replacingReservationId} xsubtitle={reservation.reservationId||reservation.replacingReservationId?"Update Reservation":"No Reservation Found"} goBack={this.props.goBack} />

          {error!==null?<div className="checkin-message"><Alert color="danger">{t(error)}</Alert></div>:null}
          <div className="modal-body">
            <div className="checkin-roomType">
              <div className="title">{t("Select Room Type")}</div>
              <div className="d-flex justify-content-center">
                {[
                  {title:"Shower", name:"shower", icon: iconShower, price: this.state.privateRoom?settings.pricePrivateShower.value:settings.priceShower.value, minutes: settings.reservationMinutesShower.value },
                  {title:"Bath", name:"bath", icon: iconBath, price: this.state.privateRoom?settings.pricePrivateBath.value:settings.priceBath.value, minutes: settings.reservationMinutesBath.value },
                  {title:"Kallah", name:"kallah", icon: iconKallah, price: settings.priceKallah.value, minutes: settings.reservationMinutesBath.value, hide: !(settings.roomsAvailableKallah&&(!settings.roomsAvailableKallah.value||settings.roomsAvailableKallah.value!=='0')) },
                  {title:"Accessible", name:"handicapped", icon: iconWheelchair, price: settings.priceBath.value, minutes: settings.reservationMinutesBath.value, hide: !(settings.roomsAvailableHandicapped&&(!settings.roomsAvailableHandicapped.value||settings.roomsAvailableHandicapped.value!=='0')) },
                  {title: "Segula", name: "segula",  icon: iconSegula, price: (settings.priceSegula&&settings.priceSegula.value), minutes: (settings.reservationMinutesSegula&&settings.reservationMinutesSegula.value), hide: !(settings.priceSegula&&settings.priceSegula.value) },
                ].map((type,i) => {
                  let active = this.state[type.name];
                  if ( type.name==='shower' ) { active = (!this.state.bath&&!this.state.kallah&&!this.state.handicapped&&!this.state.segula) }
                  return !type.hide?( <div key={i}><Button type="circle" active={active} icon={<ReactSVG src={type.icon} />} value={type} xtext={type.title} key={i} onClick={() => this.handleChange(type, "type")} /><div className="btn-text">{t(type.title)}</div><div className="price"><CurrencyFormat value={type.price} /></div>{type.minutes?<div className="price">{type.minutes} {t("min")}</div>:null}</div>):null;
                })}
              </div>
            </div> 
            <div className="checkin-roomType">
              <div className="title">{t("Additional Options")}</div>
              <div className="d-flex justify-content-center">
                {[
                  // Need to use the new setting we'll add if parking is available
                  {title:"Parking", name:"parking", icon: iconParking, price: settings.priceParking.value, hide: (settings&&(!settings.parkingAvailable.value||settings.parkingAvailable.value==='0'))},
                  {title:"Extra Time", name:"doubleSlot", icon: iconClockExtra, price: settings.priceDoubleSlot.value, minutes: settings.reservationMinutesDoubleSlot.value },
                  {title:"Chabad Bor", name:"chabadBor", icon: iconChabadBor, hide: (settings&&settings.roomsAvailableChabad&&(!settings.roomsAvailableChabad.value||settings.roomsAvailableChabad.value==='0')) },
                  {title:settings&&settings.privateRoomLabel&&settings.privateRoomLabel.value?settings.privateRoomLabel.value:"Jacuzzi Room", name:"privateRoom", icon: "award", hide: (settings&&settings.roomsAvailablePrivateRoom&&(!settings.roomsAvailablePrivateRoom.value||settings.roomsAvailablePrivateRoom.value==='0')) },
                ].map((type,i) => {
                  return !type.hide?
                    <div key={i}><Button type="circle" active={this.state[type.name]} icon={["privateRoom"].includes(type.name)?<FontAwesomeIcon className="icon" icon={type.icon} />:<ReactSVG src={type.icon} />} value={type} xtext={type.title} onClick={() => this.handleChange(type, "option")} /><div className="btn-text">{t(type.title)}</div><div className="price"><CurrencyFormat value={type.price} /></div>{type.minutes?<div className="price">+{type.minutes} {t("min")}</div>:null}</div>
                  :null
                  })}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <Button type="secondary" size="lg" loading={isSubmitting} onClick={this.handleSubmit} disabled={fridayInfoRequired}>{reservation.reservationId||reservation.replacingReservationId?t("Update Reservation"):t("Create Reservation")}</Button>
            {settings.fridayLocationSystem&&settings.fridayLocationSystem.value==="True"&&settings.shabbosMode&&settings.shabbosMode.value?<div className="col-12 mt-2 cursor-pointer hover-underline" onClick={this.modalToggleFridayLocation}>{reservation.fridayLocationId?t("Update Friday Location"):t("Add Friday Location")}</div>:null}
          </div>
          </>
          :null}
        </>}
      </SettingsContext.Consumer>
    );
  }
}

export default withTranslation()(CheckinRoomType);
